// assets
import {
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconTicket,
    IconMessages,
    IconPencil,
    IconUserCheck,
    IconBuilding,
    IconMailbox,
    IconTriangleSquareCircle,
    IconExclamationMark,
    IconBuildingSkyscraper,
    IconAdjustmentsHorizontal,
    IconBellPlus,
    IconGolf
} from '@tabler/icons-react';

// constant
const icons = {
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconTicket,
    IconMessages,
    IconPencil,
    IconUserCheck,
    IconBuilding,
    IconMailbox,
    IconTriangleSquareCircle,
    IconExclamationMark,
    IconBuildingSkyscraper,
    IconAdjustmentsHorizontal,
    IconBellPlus,
    IconGolf
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const admin = {
    id: 'admin-routes',
    title: 'Administración',
    type: 'group',
    children: [
        {
            id: 'employes',
            title: 'Empleados',
            type: 'item',
            url: '/admin/users',
            icon: icons.IconUsers,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'admins',
            title: 'Administradores y Gerentes',
            type: 'item',
            url: '/admin/all',
            icon: icons.IconUserCheck,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'production-goal',
            title: 'Meta de producción',
            type: 'item',
            url: '/admin/production-goal',
            icon: icons.IconGolf,
            external: false,
            breadcrumbs: false,
            target: false
        }
    ]
};

export default admin;
